import React, { useContext, useState, useEffect, useRef } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { getStringFromId } from "../../helpers/vernacular";
import { CLIENT_URLS } from "constants/urls";
import { ErrorModalContext } from "wrapper/ErrorModalWrapper/context";
import { PAYMENT_ERROR_MESSAGE } from "constants/paymentStatus";
import { redirectToCheckoutPage } from "helpers/utils/redirectToCheckoutPage";
import {
  trackAddNewAddressClick,
  trackEditAddressPageLoad,
  trackShipToThisAddressClick,
} from "pages/SavedAddresses/dependencies/tracking";
import { AddressContext } from "wrapper/AddressWrapper/context/addressContext";
import { VERNACULAR_DEFAULT_MESSAGES, VERNACULAR_STRING_IDS } from "constants/vernacularConstants";
import { getCapitalizeString } from "helpers/utils/capitalize";
import { SavedAddressContextProvider } from "./context/savedAddressContext";
import { ApplicationContext } from "wrapper/ApplicationWrapper/context";
import { ORIGIN_SOURCE } from "shared/constants/index";
import { setCookie } from "../../helpers/utils/cookie";
import { DEVICE_TYPE, PAGE_NAMES, TRACKING_EVENTS } from "constants/index";
import { allTrackingHandlerForApps } from "helpers/utils/trackingHandler";
import { doRedirect } from "helpers/utils/redirection";
import { ADDRESS_TYPE, DEFAULT_MESSAGE } from "constants/address";
import { AppCallback, doCallAppCallback } from "helpers/utils/webView";
import { CommonContextContext } from "wrapper/CommonWrapper/context";
import { getPlatform } from "../../helpers/index";
import { showAddressNotServiceAbleBottomSheet, getRequestParamsForServiceability } from "wrapper/AddressWrapper/dependencies/helpers";
import { trackPincodeNonServiceable, trackShipToThisAddressClicksError } from "wrapper/NewAddressWrapper/dependencies/tracking";
import { getQueryStrings } from "layouts/CheckoutPayment/helpers";


/**
 * @description
 * handling of all the logics such as clicks and redirections are done
 * passed down to view component as config object in props
 * @param props - config
 * @returns
 */
export const SavedAddressWrapper = (props: any) => {
  const history = useHistory();
  const platform = getPlatform();
  const searchLocation = useLocation();
  const errorModalContext = useContext(ErrorModalContext);
  const { applicationData } = useContext(ApplicationContext);
  const {
    setAddressType,
    setAddress,
    cartAddressId,
    getAddressServiceability,
    pincode,
    addressLoading,
    addresses,
    isShow,
    setIsShow,
    totalAddressCount,
    cartInfo,
    isShipToAddressClick,
    isPincodeBottomSheetVisible,
    setIsPincodeBottomSheetVisible,
    setIsShipToAddressClick
  } = useContext(AddressContext);
  const { setCanRedirectToNewPaymentScren, setCartInfo} = useContext(CommonContextContext);
  const { deviceType, isApp, isBeautyPlatform} = applicationData;
  const openErrorModal = errorModalContext?.openErrorModal;
  const isAddressDtoNull = (cartInfo as any)?.shippingAddress ? false : true;
  const [selectedAddress, setSelectedAddress] = useState({
    postcode: "",
    isSetDefault: false,
    customerAddressId: "",
    countryId: "",
  } as AddressDataType);
  const [checkedId, setCheckedId] = useState("");
  const [isDefaultAddress, setIsDefaultAddress] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const queryResult = getQueryStrings(searchLocation.search);
  const srcPage = queryResult.get('src') || '';
  const selectedAddressId = queryResult.get('addressId') || '';
  const srcPageIsImport = srcPage == PAGE_NAMES.IMPORT_PAGE;
  const isAddressChanged = useRef<boolean>(false);

  /**
   * helper functions starts
   */
  const handleBackButtonClick = () => {
    if (isApp && isAddressDtoNull) {
      doCallAppCallback({
        name: AppCallback.DO_REDIRECT_TO_CART,
        data: {},
      });
      return;
    }

    history.goBack();
  };

  /**
   * handling of check box click on  saved address
   */
  const handleCheckBoxClick = (address: AddressDataType) => {
    if(checkedId !== address.customerAddressId){
      isAddressChanged.current = true;
    }
    setSelectedAddress(address);
    setCheckedId(address.customerAddressId);
  };

  const getPinCodeDetails = (
    params: { pincode: string; countryCode: string },
    isInternational?: boolean,
    isFormSubmit = false
  ) => {

    const requestParams = getRequestParamsForServiceability({
      pincode: params.pincode,
      isInternational,
      countryToShip: params.countryCode,
      deviceType,
      isBeautyPlatform,
    });
    
    getAddressServiceability(requestParams)
      .then((response: IAddressServiceability) => {
        if (response?.success) {
          if (isFormSubmit) {
            if (deviceType === DEVICE_TYPE.MOBILE) {
              setCookie("addressIdDel", selectedAddress.customerAddressId, 365);
              setCookie("pinCodeDel", selectedAddress.postcode, 365);
              redirectToCheckoutPage(
                history,
                pincode === selectedAddress.postcode,
                isAddressDtoNull,
                "",
                addresses.length,
                setIsShipToAddressClick,
                srcPageIsImport
              );
              
            } else {
              doRedirect({
                url: CLIENT_URLS.PAYMENT_BASE_URL,
                history,
                isClientRedirection: true,
                historyState: {},
              });
            }
            setIsLoading(false);
          }
        }

        if (!response.success) {
          trackPincodeNonServiceable({pincode: selectedAddress.postcode});
          setIsPincodeBottomSheetVisible(true);
          setIsLoading(false);
        }
      })
      .catch(() => {
        setIsLoading(false);
      });
  };

  /**
   * handling of edit click on saved address
   */

  const handleEditClick = (customerAddressId: string) => {
    setAddressType(ADDRESS_TYPE.EDIT);
    allTrackingHandlerForApps({ event: TRACKING_EVENTS.EDIT_ADDRESS_LOADS, isApp });
    trackEditAddressPageLoad();
    if (deviceType === DEVICE_TYPE.DESKTOP) {
      history.replace(`${CLIENT_URLS.EDIT_ADDRESS}?id=${customerAddressId}`);
    } else {
      doRedirect({
        url: srcPageIsImport
        ? `${CLIENT_URLS.EDIT_ADDRESS}?id=${customerAddressId}&src=${PAGE_NAMES.IMPORT_PAGE}`
        : `${CLIENT_URLS.EDIT_ADDRESS}?id=${customerAddressId}`,
        history,
        isClientRedirection: true,
      });
    }
  };

  /**
   * handling of add new address click on saved address
   */
  const handleAddAddressClick = () => {
    setIsShow(deviceType === DEVICE_TYPE.DESKTOP);
    setAddressType(ADDRESS_TYPE.ADD);

    if (deviceType === DEVICE_TYPE.DESKTOP) {
      history.replace(CLIENT_URLS.NEW_ADDRESS);
    } else {
      doRedirect({
        url: srcPageIsImport
          ? `${CLIENT_URLS.NEW_ADDRESS}?src=${PAGE_NAMES.IMPORT_PAGE}`
          : `${CLIENT_URLS.NEW_ADDRESS}`,
        history,
        isClientRedirection: true
      });
    }

    /** tracking function for new address click */
    trackAddNewAddressClick();
  };

  const onSideBarOverlayClick = () => {
    setIsShow(false);
  };

  const pincodeBottomSheetTitle = getStringFromId(
    VERNACULAR_STRING_IDS.ADDRESS_BOTTOM_SHEET_TITLE,
    VERNACULAR_DEFAULT_MESSAGES.ADDRESS_BOTTOM_SHEET_TITLE
  );
  const pincodeBottomSheetSubTitle = (postcode: string) => getStringFromId(
    VERNACULAR_STRING_IDS.DYNAMIC_WE_CURRENTLY_DONOT_DELIVER_TO,
    `Currently we do not deliver to ${postcode}`
  );

  /**
   * handling of ship to this address click on saved address
   */
  const handleShipAddressClick = (address: AddressDataType) => {
    setCanRedirectToNewPaymentScren(true);
    setIsLoading(true);

    const params = {
      deviceType,
      domain: platform,
      addressId: address?.customerAddressId,
      originSource: ORIGIN_SOURCE.ADDRESS,
    };

    if (deviceType === DEVICE_TYPE.DESKTOP) {
      setSelectedAddress(address);
    }

    setAddress(params)
      .then(response => {
        const isAddressDefault =
          address?.customerAddressId === (addresses?.[0] as any)?.customerAddressId;
        setCartInfo(response);
        // tracking function
        trackShipToThisAddressClick({
          interactionLocation: PAGE_NAMES.SAVED_ADDRESS,
          isInputChanged: isAddressChanged.current,
        });
        // apps tracking for ship to this address click on saved address page
        allTrackingHandlerForApps({
          event: TRACKING_EVENTS.SHIP_TO_ADDRESS_CLICKS,
          isDefaultAddress: isAddressDefault,
          interactionLocation: PAGE_NAMES.SAVED_ADDRESS,
          isApp,
        });

        getPinCodeDetails(
          {
            pincode: response?.shippingAddress?.postcode || selectedAddress.postcode,
            countryCode: response?.shippingAddress?.country || selectedAddress.countryId,
          },
          false,
          true
        );
      })
      .catch((error) => {
        setIsLoading(false);
        trackShipToThisAddressClicksError({
          errorType: error.message,
          interactionLocation: PAGE_NAMES.SAVED_ADDRESS
        });
        if (showAddressNotServiceAbleBottomSheet(error?.code)) {
          trackPincodeNonServiceable({ pincode: selectedAddress.postcode });
          if (deviceType === DEVICE_TYPE.DESKTOP) {
            openErrorModal(pincodeBottomSheetTitle, pincodeBottomSheetSubTitle(address?.postcode));
          }
          setIsPincodeBottomSheetVisible(true);
          return;
        }
        openErrorModal(PAYMENT_ERROR_MESSAGE.SOMETHING_WENT_WRONG, "");
      });
  };

  const onPincodeBottomSheetClose = () => {
    setIsPincodeBottomSheetVisible(false);
  };

  /**
   * helper functions ends
   */

  /**
   * when addressDto is null and user is having saved address
   * user journey
   * cart -> saved -> new
   * new -> saved -> payment
   * Note : We are maintaining the stack don't use contextual routing
   */
  useEffect(() => {
    if (isShipToAddressClick) {
      window.history.replaceState(
        null,
        document?.title,
        `${CLIENT_URLS.PAYMENT_BASE_URL}?shipTothisAddressClicked=true`
      );
      window.location.reload();
    }
  }, [isShipToAddressClick]);

  useEffect(() => {
    if (Array.isArray(addresses) && addresses.length > 0) {
      let cartSelectedAddress: any;
      if (selectedAddressId) {
        /**
         * If addressId is present in query param then selecting that address
         */
        cartSelectedAddress = addresses.find(
          address => (address as any)?.customerAddressId === selectedAddressId
        ) || addresses[0];
      } else {
        /**
         * we are moving default address to starting index in transformer
         * always set checked id to first address even if no address is set as default FC-1122
         * if user is having addressDto in cart refresh call then we are selecting that address
         * if it is null then selection first address
         */

        cartSelectedAddress =
          addresses.find(
            address =>
              (address as any)?.customerAddressId === (cartInfo as any)?.shippingAddress?.addressId
          ) || addresses[0];
      }

      if (cartSelectedAddress && !checkedId) {
        setCheckedId(cartSelectedAddress?.customerAddressId);
        setIsDefaultAddress(true);
        setSelectedAddress(cartSelectedAddress);
      }
    }
  }, [addresses, cartAddressId, addressLoading]);

  useEffect(() => {
    if (checkedId) {
      getPinCodeDetails(
        {
          pincode: selectedAddress.postcode,
          countryCode: selectedAddress.countryId,
        },
        false,
        false
      );
    }
  }, [checkedId]);

  const vernacularMessages = {
    headerTitle:
      getStringFromId(
        VERNACULAR_STRING_IDS.SELECT_ADDRESS,
        VERNACULAR_DEFAULT_MESSAGES.SELECT_ADDRESS
      ) || DEFAULT_MESSAGE.HEADER_TITLE,
    addNewAddress:
      getStringFromId(
        VERNACULAR_STRING_IDS.ADD_NEW_ADDRESS,
        VERNACULAR_DEFAULT_MESSAGES.ADD_NEW_ADDRESS
      ) || DEFAULT_MESSAGE.ADD_NEW_ADDRESS,
    defaultTitle:
      getStringFromId(VERNACULAR_STRING_IDS.DEFAULT, VERNACULAR_DEFAULT_MESSAGES.DEFAULT) ||
      DEFAULT_MESSAGE.DEFAULT,
    editTitle:
      getCapitalizeString(
        getStringFromId(VERNACULAR_STRING_IDS.EDIT, VERNACULAR_DEFAULT_MESSAGES.EDIT)
      ) || DEFAULT_MESSAGE.EDIT,
    shipToThisAddress:
      getStringFromId(
        VERNACULAR_STRING_IDS.SHIP_TO_THIS_ADDRESS,
        VERNACULAR_DEFAULT_MESSAGES.SHIP_TO_THIS_ADDRESS
      ) || DEFAULT_MESSAGE.SHIP_TO_THIS_ADDRESS,
    footerTitle1:
      getStringFromId(
        VERNACULAR_STRING_IDS.SAVED_ADDRESS_FOOTER_1,
        VERNACULAR_DEFAULT_MESSAGES.SAVED_ADDRESS_FOOTER_1
      ) || DEFAULT_MESSAGE.FOOTER_1,
    footerTitle2:
      getStringFromId(
        VERNACULAR_STRING_IDS.SAVED_ADDRESS_FOOTER_2,
        VERNACULAR_DEFAULT_MESSAGES.SAVED_ADDRESS_FOOTER_2
      ) || DEFAULT_MESSAGE.FOOTER_2,
  };

  const pincodeBottomSheetActionButtonText = getStringFromId(
    VERNACULAR_STRING_IDS.GOT_IT,
    VERNACULAR_DEFAULT_MESSAGES.GOT_IT
  );

  const ProviderValue = {
    addresses,
    loading: isLoading,
    handleShipAddressClick,
    handleAddAddressClick,
    handleEditClick,
    handleCheckBoxClick,
    checkedId,
    isDefaultAddress,
    vernacularMessages,
    handleBackButtonClick,
    isPincodeBottomSheetVisible,
    onPincodeBottomSheetClose,
    pincodeBottomSheetTitle,
    pincodeBottomSheetSubTitle,
    pincodeBottomSheetActionButtonText,
    setCheckedId,
    isShow,
    setIsShow,
    onSideBarOverlayClick,
    selectedAddress,
  };

  return (
    <SavedAddressContextProvider value={ProviderValue}>
      {props.children}
    </SavedAddressContextProvider>
  );
};
